import PropTypes from 'prop-types';
import React, { memo, useEffect, useState } from 'react';
import { Map, List } from 'immutable';

import AgGridTable from '../../../helpers/AgGridTable';
import { GridCard } from '../../../helpers/GridCard';
import { IconButton } from '../../../helpers/IconButton';
import { handleSortModelChanged } from '../../../../utils/sorting';

import style from './style.module.css';

const StatusCellRenderer = ({ value }) => (value === true ? 'Active' : 'Inactive');

const CompanyBuyerCEOTableComponent = ({
  data,
  onDoubleClickRow,
  onGetNextPageData,
  title,
  onAddCEOProject,
  columnDefs,
  canEditData,
  onChange,
  highlightInactive,
}) => {
  const [gridApi, setGridApi] = useState(null);
  const [rowNode, setRowNode] = useState(null);

  useEffect(() => {
    if (gridApi) {
      gridApi.sizeColumnsToFit();
      if (rowNode) {
        gridApi.redrawRows({ rowNodes: [rowNode] });
        setRowNode(null);
      }
    }

    if (data.get('focusElement')) {
      document.getElementById(data.get('focusElement')).focus();
    }
  }, [gridApi]);

  const getColumnDefs = () =>
    columnDefs.map(columnDef => {
      const field = columnDef.get('field');

      switch (field) {
        case 'status.value':
          return columnDef.merge({
            cellRendererFramework: StatusCellRenderer,
          });

        default:
          return columnDef;
      }
    });

  const handleGridReady = params => {
    setGridApi(params.api);
  };

  const handleSort = sortModel => {
    if (!canEditData) {
      return;
    }

    sortModel[0].colId = sortModel[0].colId.replace('.value', '');
    handleSortModelChanged(sortModel, data, onChange);
  };

  const getRowNodeId = data => data.order?.toString();

  const button = onAddCEOProject ? (
    <IconButton
      className={style.add}
      icon="plus"
      onClick={onAddCEOProject}
      size="sm"
      title="Add project"
      variant="primary"
    />
  ) : null;

  return (
    <GridCard className={style.table} title={title}>
      {button}
      <AgGridTable
        columnDefs={getColumnDefs()}
        getRowClass={params => (!params.data?.status?.value && highlightInactive ? style.cellInactive : '')}
        getRowNodeId={getRowNodeId}
        isFetching={data.get('isFetching')}
        onGetNextPageData={onGetNextPageData}
        onGridReady={handleGridReady}
        onRowDoubleClicked={onDoubleClickRow}
        onSortModelChanged={handleSort}
        page={data.get('page')}
        rowData={data.get('queryResults')}
        totalPages={data.get('totalPages')}
        sortable
      />
    </GridCard>
  );
};

CompanyBuyerCEOTableComponent.propTypes = {
  canEditData: PropTypes.bool.isRequired,
  columnDefs: PropTypes.instanceOf(List).isRequired,
  data: PropTypes.instanceOf(Map).isRequired,
  onChange: PropTypes.func.isRequired,
  onDoubleClickRow: PropTypes.func.isRequired,
  onGetNextPageData: PropTypes.func.isRequired,
};

/** Company buyer CEO table component. */
export const CompanyBuyerCEOTable = memo(CompanyBuyerCEOTableComponent);
